import { SimpleObjectInterface } from '@thewhite/react-global-module/lib/interfaces';
import { DateService } from '@thewhite/react-global-module/lib/services';
import * as t from 'io-ts';
import { OrganizationCategory, OrganizationCategoryType } from '../../Dictionaries/models/organizationCategory';
import BASE_STATUS from '../../Global/enums/baseStatus';

export const OrganizationMinType = t.interface({
    id: t.string,
    inn: t.union([t.string, t.null, t.undefined]),
    status: t.union([t.string, t.null, t.undefined]),
    shortName: t.union([t.string, t.null, t.undefined]),
    createDate: t.union([t.string, t.null, t.undefined]),
    category: t.union([OrganizationCategoryType, t.null, t.undefined]),
});

export interface OrganizationMinDTO extends t.TypeOf<typeof OrganizationMinType> {}

export class OrganizationMin {
    id: string;
    inn: string | null;
    createDate: Date | null;
    shortName: string | null;
    status: SimpleObjectInterface | null;
    category: OrganizationCategory | null;

    constructor(params: OrganizationMinDTO) {
        this.id = params.id;
        this.inn = params.inn ?? null;
        this.status = !!params.status
            ? BASE_STATUS[params.status]
            : null;
        this.shortName = params.shortName ?? null;
        this.category = params.category
            ? new OrganizationCategory(params.category)
            : null;
        this.createDate = !!params.createDate
            ? DateService.getValidDate(params.createDate)
            : null;
    }
}
